import { useGetModelsByRunForProject } from "modules/projects/api";

import * as flowConfig from "flows/impact-analysis-continous/config";
import { ImpactAnalysisContinousProject } from "flows/impact-analysis-continous/interfaces";

export const getDataFileId = (project: ImpactAnalysisContinousProject) =>
  project.data_files[flowConfig.INPUT_DATA];

export const getYVariable = (project: ImpactAnalysisContinousProject) =>
  project.meta_data[flowConfig.Y_COLUMN_KEY];

export const getTreatmentConditions = (
  project: ImpactAnalysisContinousProject
) => project.meta_data[flowConfig.TREATMENT_FILTERS_KEY];

export const getTreatmentControlTags = (
  project: ImpactAnalysisContinousProject
) => [
  project.meta_data[flowConfig.TREATMENT_TAG],
  project.meta_data[flowConfig.CONTROL_TAG],
];

export const useGetModelsByRun = (project: ImpactAnalysisContinousProject) =>
  useGetModelsByRunForProject(
    project,
    flowConfig.RUN_ID,
    flowConfig.TIME_STAMP
  );
